import PropTypes from "prop-types";
import { graphql } from "react-apollo";

export default function queryFactory({ query, config, propTypes, isLoaded }) {
  function Query(props) {
    const loaded = isLoaded && props.data ? isLoaded(props.data) : false;
    return props.children({ data: props.data, loaded });
  }

  Query.displayName = "Query";

  Query.propTypes = {
    children: PropTypes.func,
    data: PropTypes.object,
    ...propTypes,
  };
  return graphql(query, config)(Query);
}



// WEBPACK FOOTER //
// ./src/model/gql/queries/queryFactory.js